export var SecurityGroupRuleProtocol;
(function (SecurityGroupRuleProtocol) {
    SecurityGroupRuleProtocol["SECURITY_GROUP_RULE_PROTOCOL_TCP"] = "TCP";
    SecurityGroupRuleProtocol["SECURITY_GROUP_RULE_PROTOCOL_UDP"] = "UDP";
    SecurityGroupRuleProtocol["SECURITY_GROUP_RULE_PROTOCOL_ALL"] = "ALL";
})(SecurityGroupRuleProtocol || (SecurityGroupRuleProtocol = {}));
